import UploadFilesTable from './UploadFilesTable';
import UploadFilesColumns from './UploadFilesColumns';
import UploadFilesRows from './UploadFilesRows';

export default UploadFilesTable;
export {
  UploadFilesColumns,
  UploadFilesRows
};
